module.exports = __webpack_public_path__ + "img/37_8.78605f5d.png";